
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { getReservationClientList, getCalculateInfo, downloadCalculateExcel } from '@/api/reservationClient';
import moment from 'moment';
import CalculateDetail from './components/detail.vue';

@Component({
  components: {
    Pagination,
    CalculateDetail,
  },
})
export default class extends Vue {
  mounted() {
    this.handleDatePick('week');
    // this.getCalculateInfo();
    // this.getReservationClientList();
  }

  private dialogVisible = false;

  private handleShowDialog() {
    this.dialogVisible = true;
  }

  private listQuery: any = {
    page: 0,
    size: 10,
    orderBy: 'createDate',
    direction: 'desc',
    searchType: this.$route.query.reservationCode ? 'reservationCode' : 'name',
    searchValue: this.$route.query.reservationCode ? this.$route.query.reservationCode : '',
    useStart: moment().format('YYYY-MM-DD'),
    useEnd: moment().add(6, 'days').format('YYYY-MM-DD'),
    calculateSearch: true,
    type: 0, // 0 전체, 1 정산대기, 2 정산완료, 3 취소
    cancelSearch: false,
  }

  private dateRange: any = [moment().format('YYYY-MM-DD'), moment().add(6, 'days').format('YYYY-MM-DD')];

  private calculateInfo = {
    totalNum: 0,
    totalPrice: 0,
    holdNum: 0,
    holdPrice: 0,
    doneNum: 0,
    donePrice: 0,
    cancelNum: 0,
    cancelPrice: 0,
  }

  private searchList = [
    {
      value: 'name',
      label: '예약자',
    },
    {
      value: 'reservationCode',
      label: '예약번호',
    },
    {
      value: 'phone',
      label: '연락처',
    },
  ];

  private totalElements = 0;

  private clientList: any = [];

  private selectedClientUid = '';

  private loading = true;

  private handleDatePick(type: any) {
    if (type === 'day') {
      this.dateRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    } else if (type === 'week') {
      this.dateRange = [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')];
    } else if (type === 'month') {
      this.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')];
    } else if (type === 'year') {
      this.dateRange = [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')];
    }
    this.handleChangeDateRange();
    this.listQuery.type = 0;
    this.handleSearch();
  }

  private getCalculateInfo() {
    getCalculateInfo(this.listQuery).then((res) => {
      this.calculateInfo = res.data;
    });
  }

  private getReservationClientList() {
    this.loading = true;
    getReservationClientList(this.listQuery).then((res) => {
      this.clientList = res.data.content;
      this.totalElements = res.data.totalElements;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  }

  private handleSearch() {
    this.listQuery.page = 0;
    this.getReservationClientList();
    this.getCalculateInfo();
  }

  private handleType(type: number) {
    this.listQuery.type = type;
    if (type === 3) this.listQuery.cancelSearch = true;
    else this.listQuery.cancelSearch = false;
    this.handleSearch();
  }

  /* eslint-disable */
  private handleChangeDateRange() {
    if (this.dateRange && this.dateRange.length === 2) {
      this.listQuery.useStart = this.dateRange[0];
      this.listQuery.useEnd = this.dateRange[1];
    } else {
      this.listQuery.useStart = '';
      this.listQuery.useEnd = '';
    }
  }
  /* eslint-enable */

  private handleDetail(uid: string) {
    this.dialogVisible = !this.dialogVisible;
    this.selectedClientUid = uid;
  }

  private sortChange(item: any) {
    if (item.prop === 'date') this.listQuery.orderBy = 'createDate';
    else this.listQuery.orderBy = item.prop;

    if (item.order === 'ascending') this.listQuery.direction = 'asc';
    else if (item.order === 'descending') this.listQuery.direction = 'desc';

    if (item.order === null) {
      this.listQuery.orderBy = 'createDate';
      this.listQuery.direction = 'desc';
    }
    this.handleSearch();
  }

  /* eslint-disable */
  private handleDownloadExcel() {
    downloadCalculateExcel(this.listQuery).then((res: any) => {
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const dateRange = (this.listQuery.useStart && this.listQuery.useEnd)
          ? `_${this.listQuery.useStart}~${this.listQuery.useEnd}` : '';
      link.setAttribute('download', `정산현황${dateRange}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(() => {
      this.$message.error('엑셀 다운로드에 실패했습니다.');
    });
  }
  /* eslint-enable */
}
